import { Cascader, CascaderProps } from "antd";
import { useEffect, useState } from "react";
import { getModuleAcrionMetadata } from "../../api/logs";
export default function ModuleActionSelect(p: CascaderProps) {
    const [data, setData] = useState<any[]>([]);
    useEffect(() => {
        getModuleAcrionMetadata()
        .then(res => {
            const list = Object.keys(res);
            const _data = list.map(k => {
                return {
                    value: k,
                    label: k,
                    children: res[k].map((s: string) => {
                        return {
                            value: s,
                            label: s,
                        }
                    })
                }
            });
            setData(_data)
        })
    },[])
    return <Cascader {...p as any} options={data} />
}